export default __webpack_public_path__ + "static/media/empty-placeholder.b64ef65f.svg";